export default __webpack_public_path__ + "static/media/brands-connectup.5834698d.png";